import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Operation } from '../models/operation.model';
import { OperationType } from '../models/operation-type.enum';
import { Dictionary } from '../../../types/dictionary.type';

@Injectable()
export class UiOperationService {
    private readonly _operations$: BehaviorSubject<Dictionary<OperationType, Operation>> = new BehaviorSubject({});

    public get operations$() {
        return this._operations$.asObservable();
    }

    next(operation: Operation): void {
        let operations = this._operations$.value;
        operations = this.handleOperation(operations, operation);
        this._operations$.next(operations);
    }

    destroy(operation: Operation): void {
        const operations = this._operations$.value;
        delete operations[operation.operationType];
        this._operations$.next(operations);
    }

    private handleOperation(operations: Dictionary<OperationType, Operation>, operation: Operation): Dictionary<OperationType, Operation> {
        if (!operation.currentCommand && operation.queueCommands.length > 0) {
            operations[operation.operationType] = operation;
            operation.currentCommand = operation.queueCommands.shift();
        } else if (operation.currentCommand && operation.queueCommands.length > 0) {
            operation.currentCommand = operation.queueCommands.shift();
        } else if (operation.currentCommand && operation.queueCommands.length === 0) {
            delete operations[operation.operationType];
            operation.currentCommand = undefined;
        }

        return operations;
    }
}
